import { render, staticRenderFns } from "./PaidInvoicesTable.vue?vue&type=template&id=7fbfbefb"
import script from "./PaidInvoicesTable.vue?vue&type=script&lang=js"
export * from "./PaidInvoicesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports